import { CatalogTranslationsState } from './interface';

export const initialState: CatalogTranslationsState = {
  list: {
    data: [],
    status: null,
  },
  save: {
    status: null,
  },
  delete: {
    status: null,
  },
  refreshCache: {
    status: null,
  },
  filters: {
    catalogName: '',
    locale: '',
    scope: 'all',
    search: '',
  },
};
